import React, {useEffect, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage, useIntl} from 'react-intl';

import {IStore} from 'redux/interface';
import {getReview, getTranslations, reviewAsyncActions} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';
import {getLocalizedTitle} from 'components/header/utils';

import {closeArticle} from 'redux/content/actions';
import {ReactComponent as XpeditionIcon} from 'assets/image/menu-auth/xpedition.svg';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';
import {BotMode} from '@wholesalechange/chatcomponent';

export const ReviewChat: React.FunctionComponent = () => {
  const {
    review
  } = useSelector((state: IStore) => state.review);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const {
    locale
  } = useSelector((state: IStore) => state.translation);
  const dispatch = useDispatch();
  const {reviewId} = useParams();
  const shouldLoad = useRef(true);

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (reviewId && (!review || review.dialogId !== Number(reviewId))) {
      if (shouldLoad.current) {
        shouldLoad.current = false;
        dispatch(reviewAsyncActions[getReview](Number(reviewId)));
      }
    }
  }, []);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Reviews.toLowerCase());

    return page?.translationKey || TranslationKeys.Reviews;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Journals.toLowerCase());

    return page?.title || Pages.Reviews;
  }, [settings]);

  const localizedTitle = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Journals.toLowerCase());

    return getLocalizedTitle(page?.title, page?.titles, locale);
  }, [settings, locale]);

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/reviews">
        {localizedTitle || (
          <FormattedMessage
            id={`gritx.common.navigation.${title}`}
            defaultMessage={title}
          />
        )}
      </Link> {review && <span className="review__title-dialogue-name"> - {review.dialogName}</span>}
    </div>;
  }

  return <div className="review">
    {
      !loading.includes(getTranslations) && review && <>
        <h1 className="review__title">
          <XpeditionIcon className="review__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={review.dialogId}
          title={review.dialogName}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
